(function () {
  var PRODUCTS_ENDPOINT = '/products.json?limit=250';
  var MAX_RECOMMENDATIONS = 6;
  var MAX_COLLECTORS = 6;
  var MAX_PRODUCT_FETCH = 24;
  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  function formatMoney(value) {
    var amount = Number(value || 0);
    return 'HKD ' + amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function formatKrwMoney(value) {
    var amount = Number(value || 0) * 180;
    return 'KRW ₩' + Math.round(amount).toLocaleString('ko-KR');
  }

  function getFirstAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    return (
      variants.find(function (variant) {
        return Boolean(variant && variant.available);
      }) ||
      variants[0] ||
      null
    );
  }

  function hasAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];

    return variants.some(function (variant) {
      return Boolean(variant && variant.available);
    });
  }

  function fetchJson(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HOME_PRODUCTS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function fetchText(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('PRODUCT_HTML_REQUEST_FAILED');
      }

      return response.text();
    });
  }

  function getText(node) {
    return node && typeof node.textContent === 'string' ? node.textContent.trim() : '';
  }

  function parseCollectorData(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var followButton = doc.querySelector('.js-follow-btn[data-influencer-handle]');
    var nameNode = doc.querySelector('.imini__nm a, .imini__nm');
    var linkNode = doc.querySelector('.imini__nm a');
    var metaSpans = Array.prototype.slice.call(doc.querySelectorAll('.imini__h span'));
    var handleLabel = '';

    metaSpans.some(function (node) {
      var value = getText(node);

      if (value.indexOf('@') === 0) {
        handleLabel = value;
        return true;
      }

      return false;
    });

    var followHandle = normalizeHandle(
      followButton instanceof HTMLElement ? followButton.dataset.influencerHandle || '' : '',
    );
    var displayName = getText(nameNode);
    var supplierMeta = getText(doc.querySelector('.deal-h .imini__h'));

    return {
      followHandle: followHandle,
      followName:
        (followButton instanceof HTMLElement && followButton.dataset.influencerName) ||
        displayName ||
        '',
      displayName: displayName,
      handleLabel: handleLabel,
      collectorUrl:
        linkNode instanceof HTMLAnchorElement ? linkNode.getAttribute('href') || '' : '',
      supplierMeta: supplierMeta,
    };
  }

  function createImageMarkup(product) {
    var image = Array.isArray(product.images) && product.images.length ? product.images[0] : null;

    if (!image || !image.src) {
      return '<div class="tw-card-fallback" aria-hidden="true"></div>';
    }

    return (
      '<img src="' +
      escapeHtml(image.src) +
      '" class="tw-card-image" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy">'
    );
  }

  function buildFollowButton(collector, proxyBase) {
    if (!collector.followHandle) {
      return '';
    }

    return (
      '<button class="follow js-follow-btn" type="button" ' +
      'onclick="if (event) { event.__townwineFollowHandled = true; } if (window.TownWineFollow && typeof window.TownWineFollow.handleButtonClick === \'function\') { window.TownWineFollow.handleButtonClick(this, event); }" ' +
      'data-influencer-handle="' +
      escapeHtml(collector.followHandle) +
      '" ' +
      'data-influencer-name="' +
      escapeHtml(collector.followName || collector.displayName || '') +
      '" ' +
      'data-proxy-base="' +
      escapeHtml(proxyBase) +
      '" ' +
      'data-follow-label="팔로우" ' +
      'data-following-label="팔로잉" ' +
      'data-return-to="' +
      escapeHtml(window.location.pathname + window.location.search + window.location.hash) +
      '" ' +
      'aria-pressed="false">팔로우</button>'
    );
  }

  function buildRecommendationCard(product, collector, proxyBase) {
    var variant = getFirstAvailableVariant(product);

    if (!variant) {
      return '';
    }

    var hasCollector = Boolean(collector && (collector.followHandle || collector.displayName));
    var mainName = hasCollector ? collector.displayName || collector.followName : '컬렉터 미지정';
    var subLine = hasCollector
      ? [product.vendor, collector.handleLabel].filter(Boolean).join(' · ')
      : product.vendor || '';
    var profileUrl = hasCollector && collector.collectorUrl ? collector.collectorUrl : '';
    var initial = (mainName || product.vendor || '?').slice(0, 1);
    var subtitle = [product.product_type || 'Curated wine', product.vendor || '']
      .filter(Boolean)
      .join(' · ');
    var infoOpen = profileUrl ? '<a class="dc__ii" href="' + escapeHtml(profileUrl) + '">' : '<div class="dc__ii">';
    var infoClose = profileUrl ? '</a>' : '</div>';

    return (
      '<article class="dc" data-townwine-product-card-url="/products/' +
      escapeHtml(product.handle) +
      '">' +
      '<a class="dc__m dc__m-link" href="/products/' +
      escapeHtml(product.handle) +
      '" aria-label="' +
      escapeHtml(product.title) +
      '">' +
      createImageMarkup(product) +
      '</a>' +
      '<div class="dc__bd">' +
      '<div class="dc__inf">' +
      infoOpen +
      '<span class="mini">' +
      escapeHtml(initial) +
      '</span>' +
      '<div class="dc__nm">' +
      escapeHtml(mainName) +
      '<span>' +
      escapeHtml(subLine) +
      '</span></div>' +
      infoClose +
      buildFollowButton(collector, proxyBase) +
      '</div>' +
      '<div><h3 class="dc__t"><a href="/products/' +
      escapeHtml(product.handle) +
      '">' +
      escapeHtml(product.title) +
      '</a><em>' +
      escapeHtml(subtitle) +
      '</em></h3></div>' +
      '<div class="pg" data-townwine-inventory-card data-variant-id="' +
      escapeHtml(variant.id) +
      '" data-proxy-base="' +
      escapeHtml(proxyBase) +
      '">' +
      '<div class="pg__bar"><div class="pg__fl" style="width:0%" data-inventory-progress-bar></div></div>' +
      '<div class="pg__mt"><span data-inventory-summary>판매 수량 확인 중</span><span data-inventory-caption>재고 정보 확인 중</span></div>' +
      '</div>' +
      '<div class="pr"><div class="pr__main"><span class="now">' +
      escapeHtml(formatMoney(variant.price)) +
      '</span></div><div class="pr__sub">' +
      escapeHtml(formatKrwMoney(variant.price)) +
      '</div></div>' +
      '<a class="btn btn--dark btn--block dc__cta" href="/products/' +
      escapeHtml(product.handle) +
      '">딜 자세히 보기</a>' +
      '</div></article>'
    );
  }

  function buildCollectorCard(collector, proxyBase) {
    if (!collector || !collector.followHandle) {
      return '';
    }

    var displayName = collector.displayName || collector.followName || collector.followHandle;
    var handleLabel = collector.handleLabel || '@' + collector.followHandle;
    var profileUrl = collector.collectorUrl || '/pages/collectors';
    var initial = displayName.slice(0, 1);

    return (
      '<article class="inf-card">' +
      '<a class="inf-card__body" href="' +
      escapeHtml(profileUrl) +
      '">' +
      '<div class="av av--live">' +
      escapeHtml(initial) +
      '</div>' +
      '<div class="inf-card__n">' +
      escapeHtml(displayName) +
      '</div>' +
      '<div class="inf-card__live">진행 중</div>' +
      '<div class="inf-card__f" data-townwine-collector-summary data-influencer-handle="' +
      escapeHtml(collector.followHandle) +
      '" data-proxy-base="' +
      escapeHtml(proxyBase) +
      '">' +
      '<span data-collector-followers>0 팔로워</span><span aria-hidden="true">·</span><span data-collector-deals>누적 공구 0회</span>' +
      '</div>' +
      '</a>' +
      buildFollowButton(
        {
          followHandle: collector.followHandle,
          followName: displayName,
        },
        proxyBase,
      ) +
      '</article>'
    );
  }

  async function fetchLatestProducts() {
    var payload = await fetchJson(PRODUCTS_ENDPOINT);
    var products = Array.isArray(payload && payload.products) ? payload.products : [];
    return products
      .filter(hasAvailableVariant)
      .sort(function (left, right) {
        return new Date(right.created_at || 0).getTime() - new Date(left.created_at || 0).getTime();
      });
  }

  async function fetchCollectorDetails(products) {
    var details = new Map();

    await Promise.all(
      products.map(async function (product) {
        try {
          var html = await fetchText('/products/' + product.handle + '?view=default');
          details.set(product.handle, parseCollectorData(html));
        } catch (error) {
          console.warn('[townwine-home-live-feed] failed to fetch product detail', product.handle, error);
          details.set(product.handle, {
            followHandle: '',
            followName: '',
            displayName: '',
            handleLabel: '',
            collectorUrl: '',
          });
        }
      }),
    );

    return details;
  }

  function replaceRecommendationPanel(root, products, details, proxyBase) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    var recommendations = products
      .slice(0, MAX_RECOMMENDATIONS)
      .map(function (product) {
        return buildRecommendationCard(product, details.get(product.handle) || {}, proxyBase);
      })
      .filter(Boolean);

    if (!recommendations.length) {
      root.dataset.liveFeedReady = 'true';
      root.removeAttribute('aria-busy');
      return;
    }

    root.innerHTML = recommendations.join('');
    root.dataset.resultCount = String(products.length);
    root.dataset.liveFeedReady = 'true';
    root.removeAttribute('aria-busy');

    if (window.TownWineFollow && typeof window.TownWineFollow.init === 'function') {
      window.TownWineFollow.init(root);
    }

    if (window.TownWineCollectorStats && typeof window.TownWineCollectorStats.init === 'function') {
      window.TownWineCollectorStats.init(root);
    }
  }

  function replaceCollectorGrid(root, products, details, proxyBase) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    var collectorCards = [];
    var seenHandles = new Set();

    products.some(function (product) {
      var collector = details.get(product.handle) || {};
      var handle = normalizeHandle(collector.followHandle || '');

      if (!handle || seenHandles.has(handle)) {
        return false;
      }

      seenHandles.add(handle);
      collectorCards.push(
        buildCollectorCard(
          {
            followHandle: handle,
            followName: collector.followName || collector.displayName,
            displayName: collector.displayName || collector.followName,
            handleLabel: collector.handleLabel || '@' + handle,
            collectorUrl: collector.collectorUrl,
          },
          proxyBase,
        ),
      );

      return collectorCards.length >= MAX_COLLECTORS;
    });

    if (!collectorCards.length) {
      root.innerHTML =
        '<p style="font-size:14px;line-height:1.4;color:var(--c-text-2);margin:8px 0 0;white-space:nowrap;">지금 공구중인 컬렉터가 없습니다</p>';
      return;
    }

    root.innerHTML = collectorCards.join('');

    if (window.TownWineFollow && typeof window.TownWineFollow.init === 'function') {
      window.TownWineFollow.init(root);
    }

    if (window.TownWineCollectorStats && typeof window.TownWineCollectorStats.init === 'function') {
      window.TownWineCollectorStats.init(root);
    }
  }

  async function initHomeLiveFeed() {
    var recommendationPanel = document.querySelector('[data-home-live-recommendations]');
    var collectorGrid = document.querySelector('[data-home-live-collectors]');

    if (!(recommendationPanel instanceof HTMLElement) || !(collectorGrid instanceof HTMLElement)) {
      return;
    }

    recommendationPanel.dataset.liveFeedReady = 'false';
    recommendationPanel.setAttribute('aria-busy', 'true');

    var proxyBase =
      recommendationPanel.dataset.proxyBase ||
      collectorGrid.dataset.proxyBase ||
      DEFAULT_PROXY_BASE;

    try {
      var latestProducts = await fetchLatestProducts();
      var fetchedProducts = latestProducts.slice(0, MAX_PRODUCT_FETCH);
      var collectorDetails = await fetchCollectorDetails(fetchedProducts);

      replaceRecommendationPanel(recommendationPanel, latestProducts, collectorDetails, proxyBase);
      replaceCollectorGrid(collectorGrid, latestProducts, collectorDetails, proxyBase);

    } catch (error) {
      console.error('[townwine-home-live-feed] failed to hydrate home feed', error);
      recommendationPanel.dataset.liveFeedReady = 'true';
      recommendationPanel.removeAttribute('aria-busy');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeLiveFeed, { once: true });
  } else {
    initHomeLiveFeed();
  }
})();
